// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__qsnTD","inputWrap":"styles_inputWrap__3cLG9","input":"styles_input__2rtP_"};